import Icon from '../components/Icon.vue'

Icon.register({
  'ellipsis-v': {
    width: 192,
    height: 512,
    paths: [
      {
        d: 'M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zM24 432c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ellipsis-v.js
// module id = 1299
// module chunks = 0